import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatDialogModule, MatTabsModule, MatProgressBarModule, MatTableModule, MatInputModule, MatDatepickerModule,
    MatNativeDateModule, MatFormFieldModule, MatButtonModule, MatCheckboxModule, MatGridListModule, MatCardModule,
    MatMenuModule, MatIconModule, MatToolbarModule, MatSidenavModule, MatListModule, MatSelectModule } from '@angular/material';
import { LayoutModule } from '@angular/cdk/layout';
import { WarehouseRoutingModule } from './warehouse-routing.module';
import { MapModule } from '../map/map.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { FileDropModule } from 'ngx-file-drop';
import { CargoClosureComponent } from './closure/cargo-closure.component';
import { PickingProductComponent } from './picking/picking-product.component';
import { ModalPdfComponent } from './modal-pdf/modal-pdf.component';
import { ExitOrderComponent } from './exit-order/exit-order.component';
import { PreMerchandiseComponent } from './pre-merchandise/pre-merchandise.component';
import { PreMerchandiseLocationComponent } from './pre-merchandise-location/pre-merchandise-location.component';
import { ReceiptMerchandiseComponent } from './receipt-merchandise/receipt-merchandise.component';

@NgModule({
    declarations: [
        CargoClosureComponent,
        PickingProductComponent,
        ModalPdfComponent,
        ExitOrderComponent,
        PreMerchandiseComponent,
        PreMerchandiseLocationComponent,
        ReceiptMerchandiseComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        MatDialogModule, MatTabsModule, MatProgressBarModule, MatTableModule, MatInputModule, MatDatepickerModule, MatNativeDateModule,
        MatFormFieldModule, MatButtonModule, MatCheckboxModule, MatGridListModule, MatCardModule,
        MatMenuModule, MatIconModule, LayoutModule, MatToolbarModule, MatSidenavModule, MatListModule, MatSelectModule,
        WarehouseRoutingModule, MapModule, TranslateModule, SharedModule, NgxMaterialTimepickerModule.forRoot(), FileDropModule
    ],
    providers: [],
    entryComponents: [ModalPdfComponent, PreMerchandiseLocationComponent],
    exports: [
        CargoClosureComponent,
        PickingProductComponent,
        ModalPdfComponent,
        ExitOrderComponent,
        PreMerchandiseComponent,
        PreMerchandiseLocationComponent,
        ReceiptMerchandiseComponent
    ]
})
export class WarehouseModule {

}
